/**
 * Imperative auth fetchers. Pass a QueryClient to fetch user/auth data.
 * Use these when you need to fetch outside of React (e.g. init, loaders).
 */

import type { FetchQueryOptions, QueryClient } from '@tanstack/react-query'
import {
  userAuthQueryFetcher,
  userAuthQueryKey,
  userAuthQueryOptions,
  userQueryFetcher,
  userQueryKey,
  userQueryOptions,
} from './hooks'
import { getUserIdSelector, isLoggedInQuerySelector } from './selectors'
import type { UserAuthQuery } from '@repo/cf-user/gen/user'

export function getUserAuth(
  queryClient: QueryClient,
  options: Omit<FetchQueryOptions<UserAuthQuery>, 'queryFn' | 'queryKey'> = {},
) {
  return queryClient.ensureQueryData({
    queryFn: userAuthQueryFetcher,
    queryKey: userAuthQueryKey,
    ...userAuthQueryOptions,
    ...options,
  })
}

export function getUser(queryClient: QueryClient) {
  return queryClient.ensureQueryData({
    queryFn: userQueryFetcher,
    queryKey: userQueryKey,
    ...userQueryOptions,
  })
}

export function getIsLoggedIn(queryClient: QueryClient) {
  return getUserAuth(queryClient).then(isLoggedInQuerySelector)
}

export function getUserId(queryClient: QueryClient) {
  return getUserAuth(queryClient).then(getUserIdSelector)
}
